import {searchActions} from "./search.slice";
import {searchChangedSaga} from "./_sagas/searchChanged.saga";
import {throttle} from "redux-saga/effects";

export function* searchSaga() {
    yield throttle(500, searchActions.setText.type, searchChangedSaga);
    yield throttle(500, searchActions.setTag.type, searchChangedSaga);
    yield throttle(500, searchActions.setCardState.type, searchChangedSaga);
    yield throttle(500, searchActions.setMarkedOnly.type, searchChangedSaga);
}